import { render, staticRenderFns } from "./OurGroup.vue?vue&type=template&id=b23920a6&"
import script from "./OurGroup.vue?vue&type=script&lang=js&"
export * from "./OurGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports